import { cn } from "@/lib/utils";

export const EmptyState = ({ Art, title, desc, testid = "empty-state", children }) => (
  <div data-testid={testid} className="flex flex-col items-center rounded-xl border-2 border-dashed border-zinc-300 bg-white px-6 py-12 text-center">
    {Art && <Art className="mb-4 h-24 w-32 text-zinc-300" />}
    <div className="font-display text-lg font-bold">{title}</div>
    {desc && <p className="mt-1 max-w-sm text-sm text-zinc-500">{desc}</p>}
    {children && <div className="mt-4">{children}</div>}
  </div>
);

export const Loading = ({ label = "Memuat..." }) => (
  <div className="flex items-center gap-3 py-10 text-sm text-zinc-500" data-testid="loading">
    <div className="h-5 w-5 animate-spin rounded-full border-2 border-ink border-t-brand" /> {label}
  </div>
);

export const Num = ({ value, className }) => (
  <span className={cn("num", value < 0 && "font-bold text-brand", value === 0 && "text-zinc-300", className)}>
    {value > 0 ? `+${value}` : value}
  </span>
);

export const PrimaryBtn = ({ className, children, ...props }) => (
  <button {...props} className={cn("press inline-flex h-12 items-center justify-center gap-2 rounded-md bg-brand px-5 text-sm font-semibold text-white hover:bg-brand-dark disabled:opacity-50", className)}>
    {children}
  </button>
);

export const OutlineBtn = ({ className, children, ...props }) => (
  <button {...props} className={cn("press inline-flex h-12 items-center justify-center gap-2 rounded-md border-2 border-ink bg-white px-5 text-sm font-semibold hover:bg-ink hover:text-white disabled:opacity-50", className)}>
    {children}
  </button>
);

export const Card = ({ className, children, ...props }) => (
  <div {...props} className={cn("rounded-xl border border-zinc-200 bg-white p-5", className)}>{children}</div>
);
